import { ZodEffects, ZodError, ZodObject, z } from 'zod';
import { useEffect, useState } from 'react';
import { ZodIssue } from 'zod/lib/ZodError';
import { t } from 'i18next';

const customErrorMap: z.ZodErrorMap = (issue, ctx) => {
  if (issue.code === z.ZodIssueCode.invalid_type && issue.received === 'undefined') {
    return { message: t('Required field') };
  }
  return { message: ctx.defaultError };
};

z.setErrorMap(customErrorMap);

export function useIsZodDataValid(
  schema: ZodObject<any> | ZodEffects<any>,
  schemaToValidate: any,
  deps = [schemaToValidate],
) {
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    const parse = schema.safeParse(schemaToValidate);
    setIsValid(parse.success);
  }, deps);

  return isValid;
}

export function useZodErrors(
  schema: ZodObject<any> | ZodEffects<any>,
  schemaToValidate: any,
  deps = [schemaToValidate],
): [boolean, Record<string, string>] {
  const [errors, setErrors] = useState<Record<string, string>>({});

  useEffect(() => {
    schema
      .parseAsync(schemaToValidate)
      .then(() => setErrors({}))
      .catch((validationErrors: ZodError) =>
        setErrors(
          validationErrors.errors.reduce(
            (errors: Record<string, string>, error: ZodIssue) => ({
              ...errors,
              [error.path[0]]: error.message,
            }),
            {},
          ),
        ),
      );
  }, deps);

  return [!!Object.keys(errors).length, errors];
}
